import React from "react"


class Expresions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>

            </section>
        )
    }

}

export default Expresions


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Expressions.js